import QRCode from 'qrcode';
import React, { CSSProperties, useEffect, useState } from 'react';

interface Props {
  width?: number;
  height?: number;
  text: string;
  clasName?: string;
  style?: CSSProperties;
}
export default ({ width = 100, height = 100, text, clasName, style }: Props) => {
  const [dataURI, setDataURI] = useState<string>();

  useEffect(() => {
    if (text) {
      QRCode.toDataURL(text, { margin: 1 })
        .then(url => {
          setDataURI(url);
        })
        .catch(err => {
          console.error(err);
        });
    }
  }, [text]);

  return <img style={style} className={clasName} src={dataURI} width={width} height={height} />;
};
